import { useMemo } from "react";

const useLimitation = (active_account) => {
  const privileges = useMemo(() => {
    const connectable_channels =
      active_account?.privilege?.connectable_channels;
    const draft_tool_access = active_account?.privilege?.draft_tool_access;
    const max_brands = active_account?.privilege?.max_brands;
    const max_team_member = active_account?.privilege?.max_team_member;
    const monthly_posts = active_account?.privilege?.monthly_posts;
    const plus_brand = active_account?.privilege?.plus_brand;
    const plus_user = active_account?.privilege?.plus_user;
    const posting_is_per_channel =
      active_account?.privilege?.posting_is_per_channel;
    const purchased_brands = active_account?.privilege?.purchased_brands;
    const purchased_team_members =
      active_account?.privilege?.purchased_team_members;
    const total_addable_brands =
      active_account?.privilege?.total_addable_brands;
    const total_addable_team_members =
      active_account?.privilege?.total_addable_team_members;
    const use_2FA = active_account?.privilege?.use_2FA;
    const use_analytics = active_account?.privilege?.use_analytics;
    const use_boost_post_analytics =
      active_account?.privilege?.use_boost_post_analytics;
    const use_calendar = active_account?.privilege?.use_calendar;
    const use_campaigns = active_account?.privilege?.use_campaigns;
    const use_engagements = active_account?.privilege?.use_engagements;
    const use_ig_grid = active_account?.privilege?.use_ig_grid;
    const use_queue = active_account?.privilege?.use_queue;
    const use_thread = active_account?.privilege?.use_thread;
    const use_user_tagging = active_account?.privilege?.use_user_tagging;
    const use_bulk_queue =
      active_account?.privilege?.features_accessibility?.use_bulk_queue;
    const use_planner = true;

    return {
      connectable_channels,
      draft_tool_access,
      max_brands,
      max_team_member,
      monthly_posts,
      plus_brand,
      plus_user,
      use_2FA,
      use_analytics,
      use_boost_post_analytics,
      use_bulk_queue,
      use_calendar,
      use_campaigns,
      use_engagements,
      use_ig_grid,
      use_queue,
      use_thread,
      total_addable_brands,
      total_addable_team_members,
      posting_is_per_channel,
      purchased_brands,
      purchased_team_members,
      use_user_tagging,
      use_planner,
    };
  }, [active_account]);

  const canAddMoreBrands = privileges?.total_addable_brands > 0;

  const canPlusUser = !!privileges?.plus_user;

  const canPlusBrand = !!privileges?.plus_brand;

  const canAddMoreMembers = privileges?.total_addable_team_members > 0;

  const canCreatePost = useMemo(() => {
    let canSendPost;
    if (privileges?.monthly_posts === -1) {
      canSendPost = true;
    } else if (privileges?.monthly_posts === 0) {
      canSendPost = false;
    } else {
      canSendPost = true;
    }

    return canSendPost;
  }, [privileges]);

  const planId = active_account?.current_subscription?.plan_id ?? 1;

  const isFreePlan = planId === 1;
  const isEssentialPlan = planId === 2;
  const isGrowthPlan = planId === 3;
  const isAgencyPlan = planId === 4;

  return {
    canAddMoreBrands,
    canAddMoreMembers,
    privileges,
    canCreatePost,
    canPlusBrand,
    canPlusUser,
    planId,
    isFreePlan,
    isEssentialPlan,
    isGrowthPlan,
    isAgencyPlan,
  };
};

export default useLimitation;
